import { CommonRiskAssessment } from './add-edit-activity/common-risk-assessment';
import { RiskOfOverrun } from './add-edit-activity/risk-of-overrun';

export interface ActivityUpdateGeneralInformationRequest {
    msptActivityId?: number;
    activityTitle?: string | undefined;
    description?: string | undefined;
    lastTimeExecuted?: Date | undefined;
    commentOnLastExecution?: string | undefined;
    aeroClassification?: number | undefined;
    mainSubSystemId?: string | undefined;
    outageId?: string | undefined;
    maintenanceType?: number;
    isOutsideOfOutage?: boolean;
    hasAdviceOnExecution?: boolean;
    activityTimingComment?: string | undefined;
    estimatedGroupLifeStrategy?: number;
    planningControllingType?: number | undefined;
    oidPlannedBudget?: number | undefined;
    rbsPlannedBudget?: number | undefined;
    budgetTwoYearsPrior?: number | undefined;
    budgetPreviousYear?: number | undefined;
    budgetCurrentYear?: number | undefined;
    budgetNextYear?: number | undefined;
    overrunLikelihood?: number | undefined;
    variationDescription?: string | undefined;
    mitigatedIrr?: number;
    plantName?: string | undefined;
    currencyRate?: number;
    influenceOnOutage?: RiskOfOverrun;
    costToResolve?: RiskOfOverrun;
    costRiskAssessment?: CommonRiskAssessment;
    safetyRiskAssessment?: CommonRiskAssessment;
    regulatoryRiskAssessment?: CommonRiskAssessment;
    reputationRiskAssessment?: CommonRiskAssessment;
    environmentRiskAssessment?: CommonRiskAssessment;
    id?: number;
    readonly activityType?: number;
}

export interface SubActivityUpdateRequest {
    msptActivityId?: number;
    activityTitle?: string | undefined;
    description?: string | undefined;
    lastTimeExecuted?: Date | undefined;
    commentOnLastExecution?: string | undefined;
    aeroClassification?: number | undefined;
    mainSubSystemId?: string | undefined;
    outageId?: string | undefined;
    maintenanceType?: number;
    isOutsideOfOutage?: boolean;
    hasAdviceOnExecution?: boolean;
    activityTimingComment?: string | undefined;
    estimatedGroupLifeStrategy?: number;
    planningControllingType?: number | undefined;
    oidPlannedBudget?: number | undefined;
    rbsPlannedBudget?: number | undefined;
    budgetTwoYearsPrior?: number | undefined;
    budgetPreviousYear?: number | undefined;
    budgetCurrentYear?: number | undefined;
    budgetNextYear?: number | undefined;
    overrunLikelihood?: number | undefined;
    variationDescription?: string | undefined;
    mitigatedIrr?: number;
    plantName?: string | undefined;
    currencyRate?: number;
    influenceOnOutage?: RiskOfOverrun;
    costToResolve?: RiskOfOverrun;
    costRiskAssessment?: CommonRiskAssessment;
    safetyRiskAssessment?: CommonRiskAssessment;
    regulatoryRiskAssessment?: CommonRiskAssessment;
    reputationRiskAssessment?: CommonRiskAssessment;
    environmentRiskAssessment?: CommonRiskAssessment;
    id?: number;
    parentActivityId?: number | undefined;
    readonly activityType?: number;
}

export interface SubActivityAddRequest {
    msptActivityId?: number;
    activityTitle?: string | undefined;
    description?: string | undefined;
    lastTimeExecuted?: Date | undefined;
    commentOnLastExecution?: string | undefined;
    aeroClassification?: number | undefined;
    mainSubSystemId?: string | undefined;
    outageId?: string | undefined;
    maintenanceType?: number;
    isOutsideOfOutage?: boolean;
    hasAdviceOnExecution?: boolean;
    activityTimingComment?: string | undefined;
    estimatedGroupLifeStrategy?: number;
    planningControllingType?: number | undefined;
    oidPlannedBudget?: number | undefined;
    rbsPlannedBudget?: number | undefined;
    budgetTwoYearsPrior?: number | undefined;
    budgetPreviousYear?: number | undefined;
    budgetCurrentYear?: number | undefined;
    budgetNextYear?: number | undefined;
    overrunLikelihood?: number | undefined;
    variationDescription?: string | undefined;
    mitigatedIrr?: number;
    plantName?: string | undefined;
    currencyRate?: number;
    influenceOnOutage?: RiskOfOverrun;
    costToResolve?: RiskOfOverrun;
    costRiskAssessment?: CommonRiskAssessment;
    safetyRiskAssessment?: CommonRiskAssessment;
    regulatoryRiskAssessment?: CommonRiskAssessment;
    reputationRiskAssessment?: CommonRiskAssessment;
    environmentRiskAssessment?: CommonRiskAssessment;
    parentActivityId?: number;
    readonly activityType?: number;
}